import { __assign, __makeTemplateObject, __rest } from "tslib";
import * as React from 'react';
import styled from '@emotion/styled';
import { css } from '@emotion/core';
import { color } from '@metro-ui/tokens/js';
export var ToggleIcon = styled(function (_a) {
    var Icon = _a.Icon, isDisabled = _a.isDisabled, isTrue = _a.isTrue, rest = __rest(_a, ["Icon", "isDisabled", "isTrue"]);
    return (React.createElement(Icon, __assign({}, rest)));
})(function (_a) {
    var isDisabled = _a.isDisabled, isTrue = _a.isTrue;
    return css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    color: ", ";\n\n    ", "\n  "], ["\n    color: ", ";\n\n    ", "\n  "])), isTrue ? color.inverted : color.disabled, isDisabled && css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      color: ", ";\n    "], ["\n      color: ", ";\n    "])), isTrue ? color.inverted : color.palette.grey.tint[80]));
});
var templateObject_1, templateObject_2;
//# sourceMappingURL=ToggleIcon.js.map